<template>
    <div class="picture_header_for_status_and_room">
        <i class="dot"></i>
        <i class="status_text">{{liveStatusNameText}}</i>
        <div class="time_show">
            <picture-header-for-time-show :timeShowOfList="timeShowOfList" />
        </div>
    </div>
</template>


<script>
import { liveStatusOptions } from "../../utils/enumerate";
import { getNameTextForEnumeration, secondsFormat } from "../../utils/tool";
export default {
    components: {
        'picture-header-for-time-show': () => import('./picture_header_for_time_show.vue')
    },
    props: {
        liveClassShareLiveInfo: {
            type: Object | null,
            default: null
        },
        liveDetailInfoForApp: {
            type: Object | null,
            default: null
        }
    },
    data() {
        return {
            timeShowOfList: [
                {
                    key: 'hourList',
                    value: ['0', '0'],
                    type: 'list',
                    getMapKey: 0
                },
                {
                    key: 'dotOne',
                    value: [':'],
                    type: 'dot',
                    getMapKey: -1
                },
                {
                    key: 'minuteList',
                    value: ['0', '0'],
                    type: 'list',
                    getMapKey: 1
                },
                {
                    key: 'dotTwo',
                    value: [':'],
                    type: 'dot',
                    getMapKey: -1
                },
                {
                    key: 'secondList',
                    value: ['0', '0'],
                    type: 'list',
                    getMapKey: 2
                }
            ],
            currentTime: new Date().getTime(),
            getServerTimeTimerId: null,
            startIntervalTimerId: null
        }
    },
    computed: {
        liveStatusNameText() {
            let str = "";
            let status = this.liveClassShareLiveInfo? this.liveClassShareLiveInfo.status: -3;
            str = getNameTextForEnumeration(liveStatusOptions, status);
            if (this.liveDetailInfoForApp && this.liveDetailInfoForApp.isDebugging) str = '调试中'
            return str;
        }
    },
    watch: {
        liveClassShareLiveInfo: {
            handler: function(newval) {
                if (!newval) return;
                let { status } = newval;
                if (status === 1) {
                    this.clearIntervalForPage();
                    this.disposeTimeCalc();
                    this.startInterval();
                } else {
                    this.clearIntervalForPage();
                    this.disposeTimeShowOfList('00:00:00');
                }
            },
            immediate: true
        }
    },
    async created() {
        this.currentTime = await this.getServerTime();
        // 每隔60s获取一次服务器时间：
        let step = 60 * 1000;
        this.getServerTimeTimerId = setInterval(async () => {
            this.currentTime = await this.getServerTime();
        }, step);
        this.$once("hook:beforeDestroy", () => {
            this.clearIntervalForPage();
        });
    },
    methods: {
        // 计算直播多久了：
        disposeTimeCalc() {
            if (!this.liveClassShareLiveInfo || !this.liveDetailInfoForApp) return
            if (this.liveDetailInfoForApp.isDebugging) return
            // 直播开始时间：
            let startTime = 0
            if (typeof this.liveClassShareLiveInfo.actualStartTime === 'number') {
                startTime = this.liveClassShareLiveInfo.actualStartTime
            } else {
                startTime = new Date(this.liveClassShareLiveInfo.actualStartTime?.replace(/-/g, '/')).getTime();
            }
            // 直播开始多久了：
            let intervalTime = this.currentTime - startTime;
            let intervalTimeReal = secondsFormat(intervalTime / 1000);
            this.disposeTimeShowOfList(intervalTimeReal);
        },
        // 根据直播多久变化头部时间：
        disposeTimeShowOfList(intervalTimeReal) {
            let intervalTimeRealArr = intervalTimeReal.split(":");
            let map = new Map();
            intervalTimeRealArr.forEach((item, index) => map.set(index, item.split("")));
            this.timeShowOfList = this.timeShowOfList.map(item => {
                if (item.getMapKey !== -1) {
                    item.value = map.get(item.getMapKey);
                }
                return item;
            })
        },
        // 秒级更新头部时间：
        startInterval() {
            this.startIntervalTimerId = setInterval(() => {
                this.currentTime += 1000;
                this.disposeTimeCalc();
            }, 1000);
        },
        // 获取服务器时间：
        getServerTime() {
            return new Promise(async (resolve, reject) => {
                // 老的接口：
                // let { data: result } = await this.$http.getServerTime()
                // if (result.code !== 200) return resolve(new Date().getTime())
                // let time = result.result? result.result: new Date().getTime()
                // resolve(time)
                // 新的接口：
                const result = await this.$http.getLocalTime()
                if (result.code !== 200) return resolve(new Date().getTime())
                const time = result.rt ? new Date((result.rt).replace(/-/g, '/')).getTime() : new Date().getTime()
                resolve(time)
            })
        },
        // 清除定时器：
        clearIntervalForPage() {
            this.getServerTimeTimerId && clearInterval(this.getServerTimeTimerId);
            this.startIntervalTimerId && clearInterval(this.startIntervalTimerId);
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin verticalAndCrosswiseCenter {
    display: flex;
    justify-content: center;
    align-items: center;
}
@keyframes dotChange {
  0% {
    box-shadow: 0px 0px 0px #dc8e6c;
  }
  100% {
    box-shadow: 0 0 20px #dc8e6c;
  }
}
.picture_header_for_status_and_room {
    width: auto;
    height: inherit;
    padding: 0 16px;
    display: flex;
    align-items: center;
    .dot {
        width: 8px;
        height: 8px;
        background: #FF6F33;
        border-radius: 50%;
        animation: dotChange 1s 0s linear infinite;
    }
    .status_text {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        margin-left: 10px;
        margin-right: 7px;
    }
    .time_show {
        width: auto;
        height: 40px;
        margin-left: 6px;
        @include verticalAndCrosswiseCenter();
    }
    .network_status {
        margin-left: 15px;
    }
    .network_info_of_status {
        height: 60px;
        @include verticalAndCrosswiseCenter();
        user-select: none;
        cursor: pointer;
        img {
            width: 30px;
            display: block;
            transform: translateY(-3px);
        }
    }
}
</style>